import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTheme } from '@emotion/react';

import { redirectToUrl } from '@gumtree/shared/src/util/browser-service';
import { getNonFalsyUrlSearchParams } from '@gumtree/shared/src/util/url-params';

import { Button } from '@gumtree/ui-library';
import type { SrpState, SrpUseDispatch } from '../../reducers';
import { trackGA4FiltersDiffThunk } from '../../reducers/current-filter-states';
import { searchButtonCss } from './styles';

const Search = () => {
    const theme = useTheme();
    const dispatch = useDispatch() as SrpUseDispatch;

    const {
        resultsPage: { currentFilterStates, searchResultAbundance },
    } = useSelector((data: SrpState): SrpState => data);

    const onClick = () => {
        dispatch(trackGA4FiltersDiffThunk());
        redirectToUrl(`/search?${getNonFalsyUrlSearchParams(currentFilterStates)}`);
    };

    return (
        <Button
            display="primary"
            label={`Search (${searchResultAbundance.toLocaleString()})`}
            onClick={onClick}
            css={searchButtonCss(theme)}
        />
    );
};

export default Search;
